var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#F68634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7594 12.1291C17.7594 11.1863 16.965 10.4198 15.9883 10.4198C15.0125 10.4198 14.2173 11.1863 14.2173 12.1291C14.2173 13.071 15.0125 13.8381 15.9883 13.8381C16.965 13.8381 17.7594 13.071 17.7594 12.1291ZM20.2656 12.1291C20.2656 14.4053 18.3477 16.2569 15.9884 16.2569C13.6295 16.2569 11.7111 14.4053 11.7111 12.1291C11.7111 9.85207 13.6295 8 15.9884 8C18.3477 8 20.2656 9.85207 20.2656 12.1291ZM20.2136 18.634C19.4402 19.1029 18.6005 19.4354 17.7299 19.6269L20.121 21.9352C20.6108 22.4071 20.6108 23.1734 20.121 23.6457C19.6316 24.1181 18.8385 24.1181 18.3497 23.6457L15.9988 21.3774L13.6499 23.6457C13.405 23.8817 13.084 23.9997 12.7631 23.9997C12.4427 23.9997 12.1223 23.8817 11.8774 23.6457C11.388 23.1734 11.388 22.4076 11.8768 21.9352L14.2682 19.6269C13.3976 19.4354 12.5579 19.1024 11.7845 18.634C11.1992 18.2778 11.0233 17.5315 11.3921 16.966C11.7599 16.3998 12.5333 16.2293 13.1196 16.5855C14.8707 17.6488 17.1264 17.649 18.8785 16.5855C19.4648 16.2293 20.2379 16.3998 20.6065 16.966C20.9752 17.531 20.7989 18.2778 20.2136 18.634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/OK.4b9c200695102f2025f8c4f494d97dc7.svg";
export { ForwardRef as ReactComponent };